import React, { Component } from 'react';
import AsideBlock from '../AsideBlock';
import Contacts from '~/components/Contacts';

export default OriginalComponent =>
  class WrapperComponent extends Component {
    constructor(props) {
      super(props);
    }

    prepareAside() {
      const {
        children,
        block,
        index,
        onAddAside,
        onAsideAction,
        fullWidth,
      } = this.props;

      if (children || block.fullWidth) return null;

      block.content.aside = block.content.aside || [];
      const asideBlocks = block.content.aside.map((b, index) => {
        return (
          <AsideBlock
            key={`${b.type}_${b.sort}`}
            block={b}
            index={index}
            onAction={action =>
              onAsideAction(b.type, b.sort, action, { block: block })
            }
          />
        );
      });

      // Add contacts
      if (index == 0) {
        asideBlocks.unshift(
          <Contacts key={'contacts'} page={$('#page-editor').data('page')} />,
        );
      }

      return (
        <div className="block__aside">
          <div className="absolute-wrapper">
            {asideBlocks}
            <button
              className="editor__btn-addblock for-admin"
              onClick={() => onAddAside({ block: block })}
            >
              Добавить блок
            </button>
          </div>
        </div>
      );
    }

    render() {
      const { onAction, block, children } = this.props;

      // const classes = ['section'];
      // if (this.props.index == 0) classes.push('section--pt-lg');

      if (children) {
        return (
          <div className="inside-editor__wrap">
            <OriginalComponent {...this.props} />
            <div className="block__actions for-admin">
              <div className="block__actions_border"></div>
              <div className="block__actions_btns">
                <button
                  onClick={() => onAction('up')}
                  className="block__actions--up"
                ></button>
                <button
                  onClick={() => onAction('down')}
                  className="block__actions--down"
                ></button>
                <button
                  onClick={() => onAction('edit')}
                  className="block__actions--edit"
                ></button>
                <button
                  onClick={() => onAction('del')}
                  className="block__actions--del"
                ></button>
              </div>
              <div className="block__actions_add">
                <button
                  onClick={() => onAction('add')}
                  className="block__actions--new"
                ></button>
              </div>
            </div>
          </div>
        );
      }

      const classes = ['block__content'];
      if (block.fullWidth) classes.push('block__content--full');
      if (block.noPadding) classes.push('block__content--no-padding');
      if (block.blackBG) classes.push('block__content--black-bg');

      return (
        <section className="block" id={`${block.type}_${block.sort}`}>
          <div className={classes.join(' ')}>
            <OriginalComponent {...this.props} />
            <div className="block__actions for-admin">
              <div className="block__actions_border"></div>
              <div className="block__actions_btns">
                <button
                  onClick={() => onAction('up')}
                  className="block__actions--up"
                ></button>
                <button
                  onClick={() => onAction('down')}
                  className="block__actions--down"
                ></button>
                <button
                  onClick={() => onAction('edit')}
                  className="block__actions--edit"
                ></button>
                <button
                  onClick={() => onAction('del')}
                  className="block__actions--del"
                ></button>
              </div>
              <div className="block__actions_add">
                <button
                  onClick={() => onAction('add')}
                  className="block__actions--new"
                ></button>
              </div>
            </div>
          </div>
          {this.prepareAside()}
        </section>
      );
    }
  };
